import { render } from "./ProductView.vue?vue&type=template&id=c8bad2ce"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"

import "./ProductView.vue?vue&type=style&index=0&id=c8bad2ce&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__